import React from 'react'

export const Item = (props) => {

    const Icon = props.icon
    return (
        <li className={props.active ? 'item active' : 'item'} onClick={props.onClick}>
            <Icon />
            <span>{props.text}</span>
        </li>
    )
}

export default Item